import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Switch,
  Typography
} from "@material-tailwind/react";
import Dict from "../../../helper/dict";
import React, {useEffect, useState} from "react";
import "../../../style/datePicker.css"
import {submitStageDegree, updateStageDegree} from "../../../services/stage_degree/stage_degree";

export function StageDegreeForm({stageDegree, open, setOpen, setLastDataRefresh, setGridSelectedRow}) {
  const handleOpen = () => setOpen(!open);

  const [id, setId] = useState(null)
  const [title, setTitle] = useState("")
  const [description, setDescription] = useState(null);
  const [orderBy, setOrderBy] = useState(null);
  const [status, setStatus] = useState(false)

  useEffect(() => {
    setId(stageDegree?.id ?? null);
    setTitle(stageDegree?.title ?? "");
    setDescription(stageDegree?.description ?? "");
    setOrderBy(stageDegree?.order_by ?? "");
    setStatus(stageDegree?.status === 'enable' ?? false);
  }, [stageDegree]);

  const save = async () => {
    const data = {
      id: id,
      title: title,
      description: description,
      order_by: parseInt(orderBy),
      status: status ? "enable" : "disable"
    };
    let result;

    if (!id) {
      result = await submitStageDegree(data);
    } else {
      result = await updateStageDegree(data);
    }

    if (result.status === 200) {
      setGridSelectedRow(false)
      setLastDataRefresh(Date.now())
      handleOpen()
    }
  };

  return (
    <>
      <Dialog open={open} handler={handleOpen} animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
        <DialogHeader className="border-b">
          <Typography>ویرایش/جدید</Typography>
        </DialogHeader>
        <DialogBody className="flex flex-col gap-4 overflow-y-scroll">

          <div className="mb-4">
            <Input variant="standard"
                   value={title}
                   label={Dict('title')}
                   placeholder={Dict('title')}
                   onChange={(e) => {
                     setTitle(e.target.value)
                   }}
            />
          </div>

          <div className="mb-4">
            <Input variant="standard"
                   value={description}
                   label="توضیحات"
                   placeholder="توضیحات"
                   onChange={(e) => {
                     setDescription(e.target.value)
                   }}
            />
          </div>

          <div className="mb-4">
            <Input variant="standard"
                   value={orderBy}
                   label={Dict('order_by')}
                   placeholder={Dict('order_by')}
                   type="number"
                   min="0"
                   onChange={(e) => {
                     setOrderBy(e.target.value)
                   }}
            />
          </div>

          <div className="">
            <Switch
              label={
                <Typography color="blue-gray" className="font-medium">
                  فعال/غیرفعال
                </Typography>
              }
              checked={status}
              onChange={(e) => {
                setStatus(e.target.checked)
              }}
              labelProps={{className: "mx-4"}}
            />
          </div>
        </DialogBody>
        <DialogFooter className="space-x-2">
          <Button variant="gradient" color="gray" onClick={save} className="ml-1">
            <span>ذخیره</span>
          </Button>
          <Button variant="text" color="gray" onClick={handleOpen}>
            <span>انصراف</span>
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
}